import React from "react";
import { Formik, Field, Form } from "formik";
import { Input, Select } from "../../../../../_metronic/_partials/controls";
import { jenisKelamin, pendidikan } from "../BillingUIHelpers";
import { currencyFormatter } from "../../../../../_metronic/_helpers";
import { Card } from "react-bootstrap";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";

export const BillingInvoice = ({ planPayment = {} }) => {
  return (
    <>
      {planPayment.status === "WAITING" && (
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="row">
              <div className="col">
                <h5>
                  {`${
                    planPayment.payment_method_name
                  } ${planPayment.payment_method_type &&
                    planPayment.payment_method_type.replace(/_/g, " ")}`}
                </h5>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col">
                <Card>
                  <Card.Body
                    style={{ backgroundColor: "rgba(240, 240, 240, 0.7)" }}
                  >
                    <span>Nomor Virtual Account</span>
                    <Card.Text
                      as="h4"
                      className="mt-2 d-flex justify-content-between"
                    >
                      <b>{planPayment.payment_account_number}</b>
                      <button
                        className="btn btn-outline-dark float-right"
                        onClick={() => {
                          navigator.clipboard.writeText(
                            planPayment.payment_account_number
                          );
                        }}
                      >
                        Copy
                      </button>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <Card style={{ border: "none" }}>
                  <Card.Body>
                    <span>Jumlah Tagihan</span>
                    <Card.Text as="h4" className="mt-2">
                      <b>{currencyFormatter(planPayment.payment_amount)}</b>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      )}
      {planPayment.status === "PAID" && (
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-lg-10">
            <div className="row">
              <div className="col">
                <Card>
                  <Card.Body
                    style={{
                      backgroundColor: "rgba(240, 240, 240, 0.7)",
                      textAlign: "center",
                    }}
                  >
                    <p>Terimakasih Banyak</p>
                    <Card.Text as="h4" className="mt-2">
                      Pembayaran anda telah kami terima!
                    </Card.Text>
                    <VerifiedUserIcon
                      style={{ color: "#43DEA3", fontSize: "86px" }}
                    />
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
        </div>
      )}
    </>
  );
};
